export default __webpack_public_path__ + "static/media/ALLERGEN_MILK.4d4a0ac8.png";